import type { ReactNode } from 'react';

import { LivingSky } from './LivingSky';
import './ember.css';

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Full-page marketing atmosphere: a living night sky (canvas star field + soft constellations +
 * ember motes + the occasional shooting star, drawn by <LivingSky />) over layered gradient depth
 * (asymmetric haze, warm wash, violet nebulae) with a warm hearth glow rising from the base.
 * Fixed behind scrollable content; scroll parallax + reduced-motion aware.
 */
export function EmberBackground({ children, className = '' }: Props) {
  return (
    <div className={`eb-bg ${className}`.trim()}>
      <div className="eb-bg__base" aria-hidden />
      <div className="eb-bg__haze" aria-hidden />
      <div className="eb-bg__wash" aria-hidden />
      <div className="eb-bg__nebula" aria-hidden />
      <div className="eb-bg__aurora" aria-hidden />
      <LivingSky />
      <div className="eb-bg__hearth" aria-hidden />
      <div className="eb-bg__vignette" aria-hidden />
      <div className="eb-bg__grain" aria-hidden />
      <div className="eb-bg__content">{children}</div>
    </div>
  );
}
